import { Slider, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import "react-datepicker/dist/react-datepicker.css";
import globalUseStyles from '../../styles/globalCustomStyles';

const ChooseHoursButton = (props) => {
    const t = useTranslate();
    const globalClasses = globalUseStyles();
    const hoursRange = props.hoursRange;
    const setHoursRange = props.setHoursRange;

    const handleSliderChange = (event, newValue) => {
        setHoursRange(newValue);
    };

    const formatValueLabel = (value) => {
        const hours = Math.floor(value);
        const minutes = "00"
        return `${hours}h${minutes}`;
    };

    return (
        <div>
            <Typography variant="h9" style={{ marginRight: '10px' }}>{t('resources.global.chooseHoursTitle')}</Typography>
            <div className={globalClasses.hoursPicker}>
                <Slider
                    value={hoursRange}
                    onChange={handleSliderChange}
                    valueLabelDisplay="auto"
                    valueLabelFormat={formatValueLabel}
                    min={0}
                    max={24}
                    step={1}
                    marks={[
                        { value: 0, label: '00:00' },
                        { value: 6, label: '06:00' },
                        { value: 12, label: '12:00' },
                        { value: 18, label: '18:00' },
                        { value: 24, label: '24:00' }
                    ]}
                    className={globalClasses.hoursPickerSlider}
                />
            </div>
        </div>
    );
}

export default ChooseHoursButton;